import script from "./SampleImages.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleImages.vue?vue&type=script&setup=true&lang=js"

import "./SampleImages.vue?vue&type=style&index=0&id=39490152&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39490152"]])

export default __exports__